export default class Toasts {
  static toasts = {
    show: Vue.toasted.show,
    info: Vue.toasted.info,
    success: Vue.toasted.success,
    danger: Vue.toasted.error,
    warning: Vue.toasted.global.warning,
  };

  static convert(key) {
    if (Toasts.toasts.hasOwnProperty(key)) {
      return Toasts.toasts[key];
    }

    return Toasts.toasts[0];
  }
}
